import { tv } from 'tailwind-variants'

export const textCardVariants = tv({
  slots: {
    container: 'flex flex-col',
    sourceUrl: 'text-mili italic pb-mili text-secondary-medium cursor-pointer hover:text-primary-medium'
  }
})
